import { render, staticRenderFns } from "./BaseModalGeral.vue?vue&type=template&id=4075fe94&lang=pug"
import script from "./BaseModalGeral.vue?vue&type=script&lang=js"
export * from "./BaseModalGeral.vue?vue&type=script&lang=js"
import style0 from "./BaseModalGeral.vue?vue&type=style&index=0&id=4075fe94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports